import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const RecallPublishedQuoteModal = ({
  isOpen,
  onConfirm,
  onReject,
  loading
}) => {
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.recallQuoteModal.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.recallQuoteModal.message"
    }),
    "data-selenium-test": "recall-quote-modal",
    "data-test-id": "recall-quote-modal",
    use: "conversational",
    onReject: onReject,
    size: "auto",
    onConfirm: onConfirm,
    ConfirmButton: UILoadingButton,
    confirmButtonProps: {
      loading
    },
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.recallQuoteModal.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.recallQuoteModal.cancel"
    })
  });
};
export default /*#__PURE__*/memo(RecallPublishedQuoteModal);